import React, { useState } from "react";
import "./editratingmodal.css";

const EditRatingModal = (props) => {
  const [newRating, setNewRating] = useState(props.newRating || "0");

  const handleIncrement = () => {
    setNewRating((prevRating) => (parseInt(prevRating, 10) + 1).toString());
    props.setNewRating((prevRating) => (parseInt(prevRating, 10) + 1).toString());
  };

  const handleDecrement = () => {
    setNewRating((prevRating) => (parseInt(prevRating, 10) - 1).toString());
    props.setNewRating((prevRating) => (parseInt(prevRating, 10) - 1).toString());
  };

  return (
    <div className={`modal ${props.visible ? "show" : ""}`}>
      <div className="modal-content">
        <h2 className="modal-title">Change Rating</h2>

        <div className="row-rating">
          {/* <div className="rating-controls"> */}
           <button className="decrement-btn" onClick={handleDecrement}>-</button>
           
             <input
            type="text"
            className="rating-input"
            placeholder="-1"
            value={props.newRating}
            onChange={(e) => props.setNewRating(e.target.value)}
          />
            <button className="increment-btn" onClick={handleIncrement}>+</button>
          {/* </div>  */}
        </div>

        <div className="modal-buttons">
          <button className="cancel-btn" onClick={props.onBackdropPress}>Cancel</button>
          <button className="save-btn" onClick={props.handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditRatingModal;
